import React from "react";
import api from "../servicios/api";
import { authHeaders } from "../servicios/auth";

class CambiarMiContrasena extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            contraActual: "",
            nuevaContra: "",
            confirmarContra: "",
            mensaje: "",
            tipoMensaje: ""
        };
    }

    cambioContraActual = (e) => {
        this.setState({ contraActual: e.target.value });
    }

    cambioNuevaContra = (e) => {
        this.setState({ nuevaContra: e.target.value });
    }

    cambioConfirmarContra = (e) => {
        this.setState({ confirmarContra: e.target.value });
    }

    cambiarContrasena = (e) => {
        e.preventDefault();

        const { contraActual, nuevaContra, confirmarContra } = this.state;

        if (contraActual === "" || nuevaContra === "" || confirmarContra === "") {
            this.setState({
                mensaje: "Debe completar todos los campos.",
                tipoMensaje: "warning"
            });
            return;
        }

        if (nuevaContra !== confirmarContra) {
            this.setState({
                mensaje: "La nueva contraseña y la confirmación no coinciden.",
                tipoMensaje: "warning"
            });
            return;
        }

        fetch(api + "auth/password", {
            method: "PUT",
            headers: authHeaders(),
            body: JSON.stringify({
                contraActual: contraActual,
                nuevaContra: nuevaContra
            })
        })
        .then(respuesta => respuesta.json())
        .then(datos => {
            if (datos.success) {
                this.setState({
                    contraActual: "",
                    nuevaContra: "",
                    confirmarContra: "",
                    mensaje: "Contraseña actualizada correctamente.",
                    tipoMensaje: "success"
                });
            } else {
                this.setState({
                    mensaje: datos.mensaje || "No se pudo actualizar la contraseña.",
                    tipoMensaje: "danger"
                });
            }
        })
        .catch(error => {
            
            this.setState({
                mensaje: "Error al conectar con el servidor.",
                tipoMensaje: "danger"
            });
        });
    }

    render() {
        return (
            <div className="container mt-4">
                <div className="card shadow">

                    <div className="card-header bg-dark text-white">
                        <h4>
                            <i className="bi bi-key me-2"></i>
                            CAMBIAR MI CONTRASEÑA
                        </h4>
                    </div>

                    <div className="card-body">

                        {this.state.mensaje && (
                            <div className={`alert alert-${this.state.tipoMensaje}`}>
                                {this.state.mensaje}
                            </div>
                        )}

                        <form onSubmit={this.cambiarContrasena}>

                            <div className="mb-3">
                                <label>Contraseña actual</label>
                                <input
                                    type="password"
                                    className="form-control"
                                    value={this.state.contraActual}
                                    onChange={this.cambioContraActual}
                                />
                            </div>

                            <div className="mb-3">
                                <label>Nueva contraseña</label>
                                <input
                                    type="password"
                                    className="form-control"
                                    value={this.state.nuevaContra}
                                    onChange={this.cambioNuevaContra}
                                />
                            </div>

                            <div className="mb-3">
                                <label>Confirmar nueva contraseña</label>
                                <input
                                    type="password"
                                    className="form-control"
                                    value={this.state.confirmarContra}
                                    onChange={this.cambioConfirmarContra}
                                />
                            </div>

                            <button type="submit" className="btn btn-success">
                                Guardar contraseña
                            </button>

                        </form>

                    </div>
                </div>
            </div>
        );
    }
}

export default CambiarMiContrasena;